/*jshint unused:false*/
/*global fetch */
/*global console */



// $(function () {

// /**** NAV SCROLL ****/
//     $(".side-nav a, .header-intro a, .footer-content a").click(function(e){
//         e.preventDefault();
//         // Hide nav
//         // Scroll to location
//         $("html, body").animate({ 
//             scrollTop: $( $(this).attr('href') ).position().top+50
//         }, 600);
//     });

// });

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}


// Price switch 
// function priceswitch(event) {
//   event.preventDefault();
//   document.getElementById('switch-price-type').value = this.value;
//   document.getElementById('price-switch').submit();
// }
// var price_buttons = document.querySelectorAll("#price-switch button");
// for(var i=0; i<price_buttons.length; i++){
//   price_buttons[i].addEventListener('click', priceswitch, false);
// }



// Price toggles
let typeQueryString = document.body.dataset.type;
let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
let priceSwitchForm = document.getElementById('price-switch');
let selected;

allSwitches.forEach((value) => {
  value.addEventListener('click', (e) => {

  });
  value.addEventListener('change', (val) => {
    (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
    if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
      (val.target.checked === true) ? selected = 1 : selected = 0;
    }
    toggleSwitches();
    togglePrices();
    updatePrice();
  })
})
let toggleSwitches = () => {
  allSwitches.forEach((v) => {
    (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
    (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
  })
  document.querySelector("#switch-price-type") ? document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business' : null;
  document.querySelectorAll(".price-title-type").forEach((v) => {
    v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
  })
}
let togglePrices = () => {
  priceContainers.forEach((v) => {
    if(v.querySelector('.price-personal')) {
      (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
    }
    if(v.querySelector('.price-business')) {
      (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
    }
  })
}

let updatePrice = () => {
  if (priceSwitchForm) {
    let url = priceSwitchForm.getAttribute('action');
    let formData = new FormData(priceSwitchForm);
    fetch(url, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
      headers: {
        'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(
      function(response) {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then(function(data) {
          document.querySelector("#price-switch [name=_token]").value = data.token;
        });
      }
    ).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }
}

if (typeQueryString.toLowerCase().includes('personal') || typeQueryString.toLowerCase().includes('business')) {
  (typeQueryString.toLowerCase().includes('personal')) ? selected = 0 : null;
  (typeQueryString.toLowerCase().includes('business')) ? selected = 1 : null;
  toggleSwitches();
  togglePrices();
  updatePrice();
}
// End price Toggles






//Nav Toggle
function toggleNav(el) {
  var element = el;
  var menu = document.getElementById("site-menu");
  var header = document.querySelectorAll(".site-header")[0];
  menu.classList.toggle("active");
  header.classList.toggle("active");

  if(element.querySelector("span").classList.contains("more")){
    element.innerHTML = "<span class='close'></span> Close";
  } else {
    element.innerHTML = "<span class='more'></span> Menu";
  }
}

//Accordion active
var showAccordion = function(){
  var dropdown = this.parentNode;
  dropdown.classList.toggle("active");
}

var accordionButton = document.querySelectorAll(".accordion > button");

for(var i=0; i<accordionButton.length; i++){
  accordionButton[i].addEventListener('click', showAccordion, false);
}

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');
const hamburgerSearch = document.querySelector('#headerSearch');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed'],
  onOpen: function () {
    // Navigation height
    let headerHeight = 0;
    if (document.querySelector('.site-header').classList.contains('is-sticky')) {
      headerHeight = document.querySelector('.site-header').offsetHeight;
    } else {
      headerHeight = document.querySelector('.site-header').offsetHeight + (document.body.getBoundingClientRect().top + window.scrollY);
    }
    document.querySelector('.mobile-nav.tingle-modal').setAttribute('style', `margin-top:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
    // document.querySelector('.site-menu') ? modalMobileNav.setFooterContent(document.querySelector('#price-switch').outerHTML) : null;
    // priceToggles();
  }
});
document.querySelector('.site-menu') ? modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML) : null;

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');
  // hamburger.parentElement.classList.toggle('active');

  if(hamburger.classList.contains("active")) {
    // modalMobileSearch.close();
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */

// Search Bar
var searchDropdown = function(){
  var searchRow = this.closest('.search-bar');
  searchRow.classList.toggle("active");
}

var searchBar = document.querySelectorAll(".search-bar .legend");

for(var i=0; i<searchBar.length; i++){
  searchBar[i].addEventListener('click', searchDropdown, false);
}

let popoutForm = document.querySelector('#popout-form');

if(document.getElementsByClassName('toggle-search').length>0){
  document.getElementsByClassName('toggle-search')[0].addEventListener('click', function(e){
    e.preventDefault();
    if(popoutForm===null){
      window.location.href='/search?show-search-bar=true';
      return false;
    }
    if(popoutForm.classList.contains('hidden-m')){
      popoutForm.classList.remove('hidden-m');
    } else {
      popoutForm.classList.add('hidden-m');
    }
  });
}

if (popoutForm) {
  document.getElementsByClassName('showAdvanced')[0].addEventListener('click', function(e){
    e.preventDefault();
    popoutForm.classList.add('advanced');
  });
}

function searchSorter() {
  let searchSorter = document.querySelector('#search-sorter');
  if (searchSorter) {
    searchSorter.addEventListener('change', (e) => {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('order', e.target.value);
      if ((e.target.value === 'price_asc' || e.target.value === 'price_desc') && !window.location.search.includes('initial_profile')) {
        urlParams.set('initial_profile', e.target.dataset.profile);
      }
      window.location.search = urlParams;
    })
  }
}
searchSorter();


// Back to top button
if(document.getElementById('gotosearch')!==null){
  const scrollToTopButton = document.getElementById('gotosearch');
  let smoothScrollCapture = (x) => {
    event.preventDefault();
    let id = x.currentTarget.target.getAttribute('href').split("#")[1]
    let el = document.getElementById(id);
    var x = el.getBoundingClientRect().left;
    var y = el.getBoundingClientRect().top;
    smoothScrollFunc(x, y)
  }
  let smoothScrollFunc = (x, y) => {
    event.preventDefault();
    window.scrollTo({
      top: y,
      left: x,
      behavior: 'smooth'
    });
  }
  window.addEventListener('DOMContentLoaded', () => {
    scrollToTopButton.addEventListener('click', () => {
      smoothScrollFunc(0, 0);
    })
  })
  window.addEventListener('scroll', () => {
    let pageHeight = document.body.scrollHeight;
    let currentHeight = window.scrollY;
    (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
  })
}
// End back to top button



//Menu Dropdown Toggle
// var menuDropdown = function(){
//     var dropdown = this;
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }

// //Dropdown Button
// var showDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var dropdownButton = document.querySelectorAll(".dropdown > button");

// for(var i=0; i<dropdownButton.length; i++){
//   dropdownButton[i].addEventListener('click', showDropdown, false);
// }

// //Dropdown Toggle
// var showDropdown = function(){
//     var dropdown = this.querySelector('div');
//     dropdown.classList.toggle("active");
// }

// var has_dropdown = document.querySelectorAll(".has-dropdown");

// for(var i=0; i<has_dropdown.length; i++){
//   has_dropdown[i].addEventListener('click', showDropdown, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }


// Site Search Toggle
// var searchToggle = function(){
//   search_container = document.querySelector(".popout-form");
//   if(search_container){
//     search_container.classList.toggle("active");
//   } else {
//     var elmnt = document.querySelector(".full-header-search");
//     elmnt.scrollIntoView();
//   }
// }

// var search_toggle = document.getElementById('search-toggle');
// search_toggle.addEventListener('click', searchToggle , false);



//Site Menu Dropdown Toggle
var menuDropdown = function(){
  //div inside element contains dropdown menu
  var dropdown = this.parentNode;

  //if it's already active set it not to be
  if(dropdown.classList.contains("active")){
    dropdown.classList.toggle("active");
    return;
  }
  //get current active class
  var activeClass = document.querySelectorAll(".menu-dropdown.active");
  // make it not active
  if(activeClass!=null){
    for(var i=0; i<activeClass.length; i++){
      activeClass[i].classList.toggle("active");
    }
  }

  //apply active to the div inside element that contains dropdown menu
  dropdown.classList.toggle("active");
}

var dropdownTrigger = document.querySelectorAll(".menu-dropdown > a");

for(var i=0; i<dropdownTrigger.length; i++){
  dropdownTrigger[i].addEventListener('click', menuDropdown, false);
}


// Toggle class for accordions
let acc = document.getElementsByClassName('mobile-accordion-header');
for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function(ev) {

    for (let i = 0; i < acc.length; i++) {
      if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
        continue;
      }
      acc[i].parentElement.classList.remove('active');
    }

    if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
      setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
    }
    this.parentElement.classList.toggle("active");

  });
}

//Dropdown Menu Toggle
var showMenu = function(){
  //div inside element contains dropdown menu
  var dropdown = this.parentNode.querySelector('div');
  var menuToggle = this;

  //if it's already active set it not to be
  if(dropdown.classList.contains("active")){
    dropdown.classList.toggle("active");
    menuToggle.classList.toggle("active");
    return;
  }
  //get current active class
  var activeClass = document.querySelectorAll(".dropdown-menu .active");
  // make it not active
  if(activeClass!=null){
    for(var i=0; i<activeClass.length; i++){
      activeClass[i].classList.toggle("active");
    }
  }

  //apply active to the div inside element that contains dropdown menu
  dropdown.classList.toggle("active");
  menuToggle.classList.toggle("active");

  // Nav hover
  document.querySelectorAll('*').forEach(value => {
    value.addEventListener('mouseover', (ev) => {
      if (ev.target.classList.contains('site-menu') || ev.target.classList.contains('main-nav') || ev.target.classList.contains('dropdown') || ev.target.classList.contains('tingle-modal-box') || ev.target.classList.contains('tingle-modal-box__content') || ev.target.nodeName === 'LI' || ev.target.nodeName === 'UL' || ev.target.nodeName === 'A') {

      } else {
        dropdown.classList.remove("active");
        menuToggle.classList.remove("active");
      }
    })
  })
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}

//faqs
var faqSearch = document.querySelector('.faq-search input');

if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}


//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
  e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
  classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}






/**
 * SEARCH
 */
function searchType(elem, searchType) {
  let hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  loadManufacturers(document.querySelector('#search-type').value);
  loadBodyTypes(document.querySelector('#search-type').value);
  loadSpecs(document.querySelector('#search-type').value);

  var dropdown = document.getElementsByName('model')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;
}

function loadManufacturers($type) {
  var make_dropdowns = document.getElementsByName("make");
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/manufacturers';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.has('make') ? document.querySelector('.search-form [name="make"]').value = urlParams.get('make') : null;
      urlParams.has('make') ? document.querySelector('.search-form [name="make"]').dispatchEvent(new Event('change')) : null;
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer) {

  let defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';
  let loadingOption = document.createElement('option');
  loadingOption.text = 'Loading...';
  loadingOption.value = '';
  let loadingError = document.createElement('option');
  loadingError.text = 'Loading Error, please check your internet connection';
  loadingError.value = '';

  var model_dropdowns = document.getElementsByName("model");
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;
    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($manufacturer) {
      dropdown.length = 0;
      dropdown.add(loadingOption);
      dropdown.selectedIndex = 0;

      var url = '/api/'+$type+'/models/'+$manufacturer;

      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        dropdown.length = 0;
        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
        const urlParams = new URLSearchParams(window.location.search);
        const makeParam = urlParams.get('make');
        const modelParam = urlParams.get('model');
        if (modelParam && makeParam == $manufacturer) {
          dropdown.value = modelParam;
          loadSpecs($type, modelParam);
        }
      }).catch(function(err) {
        dropdown.length = 0;
        dropdown.add(loadingError);
        dropdown.selectedIndex = 0;
        console.error('Fetch Error -', err);
      });
    }
  }
}

function loadBodyTypes($type) {
  var dropdown = document.getElementsByName('body_type')[0];

  if(typeof dropdown == 'undefined'){
    return false;
  }

  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Bodytype';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/types';

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    let keysSorted = Object.keys(data).sort(function(a, b) {
      return data[a].localeCompare(data[b])
    });
    for (let x in keysSorted) {
      let option = document.createElement('option');
      option.text = data[keysSorted[x]];
      option.value = keysSorted[x];
      dropdown.add(option);
    }
  }).catch(function(err) {
    console.error('Fetch Error -', err);
  });
}

function loadSpecs($type, $model) {
  var dropdown = document.getElementsByName('spec')[0];
  if (dropdown){
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Spec';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';

    dropdown.length = 0;
    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($model) {
      dropdown.length = 0;
      dropdown.add(loadingOption);
      dropdown.selectedIndex = 0;
      var url = '/api/'+$type+'/specs/'+$model;

      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        dropdown.length = 0;
        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
        const urlParams = new URLSearchParams(window.location.search);
        const modelParam = urlParams.get('model');
        const specParam = urlParams.get('spec_level');
        if (specParam && modelParam == $model) {
          dropdown.value = specParam;
        }
      }).catch(function(err) {
        dropdown.length = 0;
        dropdown.add(loadingError);
        dropdown.selectedIndex = 0;
        console.error('Fetch Error -', err);
      });
    }
  }
}


document.addEventListener("DOMContentLoaded", function() {
  //Lazy Load Images
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;

  const lazyLoad = function() {
    if (active === false) {
      active = true;


      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });

      active = false;
    }
  };

  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();

  // Derivative Gallery
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 2,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 4,
          }
        }
      ]
    })
  }



  if(document.getElementById('send-contact-form')){

    let button = document.getElementById('send-contact-form');
    let terms = document.querySelector('.contact-form [name=consent]');
    if(terms) {
      terms.onchange = function() {
        button.disabled = !this.checked;
      };
    }

    document.getElementById('send-contact-form').addEventListener("click", function(e) {
      e.preventDefault();
      document.body.classList.remove('loaded');

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {"action": 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let email = document.querySelector('#contact-form [name=email]').value;
          let name = document.querySelector('#contact-form [name=name]').value;
          let telephone = document.querySelector('#contact-form [name=telephone]').value;
          let comments = document.querySelector('#contact-form [name=comments]').value;
          let token = document.querySelector('#contact-form [name=_token]').value;
          let recaptcha = document.querySelector('#contact-form input[name=g-recaptcha-response]').value;

          fetch(url, {
            "method": 'POST',
            "body": JSON.stringify({
              'name': name,
              'email': email,
              'telephone': telephone,
              'comments': comments,
              '_token': token,
              'g-recaptcha-response': recaptcha
            }),
            "headers":{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status!='ok'){
              let errors = '';
              for (let i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              return alert('There was a problem with your form\n\n'+errors);
            }

            document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-content')[0].classList.add('hidden');
            document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
            document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Contact Form Submit'
            });

          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });

        });
      });

    });
  }

  if(document.getElementById('email-signup')){

    let button = document.querySelector('#email-signup');
    let terms = document.querySelector('.newsletter-form [name=consent]');
    if(terms) {
      terms.onchange = function() {
        button.disabled = !this.checked;
      };
    }

    document.getElementById('email-signup').addEventListener("click", function(e) {
      e.preventDefault();

      let recaptcha_token = null;
      recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;

      document.getElementById('email-signup').classList.add('preload');
      document.getElementById('email-signup').innerHTML = 'Please wait';
      document.getElementById('email-signup').disabled = true;

      let url = '/newsletter';
      let email = document.getElementById('newsletterEmail').value;
      let name = document.getElementById('newsletterName').value;
      let surname = document.getElementById('newsletterSurname').value;
      let token = document.getElementsByName('_token')[0].value;

      fetch(url, {
        method: 'POST',
        body: JSON.stringify({ 'name': `${name} ${surname}`, 'first_name': name, 'last_name': surname, 'email': email, 'mail_status': 'subscribed', '_token': token }),
        headers:{
          'Content-Type': 'application/json'
        }}).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        document.getElementById('email-signup').classList.remove('preload');
        document.getElementById('email-signup').innerHTML = 'Signup';
        document.getElementById('email-signup').disabled = false;

        if(data.status!='ok'){
          let errors = '';
          for (let i in data.errors) {
            errors += data.errors[i][0]+'\n';
          }
          if(typeof Swal !== 'undefined'){
            return Swal.fire({
              title: 'Whoops!',
              html: ('There was a problem with your sign up details\n\n'+errors).replace(/\n/gi,'<br>'),
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } else {
            return alert('There was a problem with your sign up details\n\n'+errors);
          }
        }

        document.getElementsByClassName('newsletter-form')[0].reset();
        // Trigger event tracking
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Newsletter Form Submit'
        });

        if(typeof Swal !== 'undefined'){
          return Swal.fire({
            title: 'Thank you!',
            text: 'You\'re signed up!',
            icon: 'success',
            confirmButtonText: 'OK'
          });
        } else {
          return alert('Thank you!');
        }

      }).catch(function(err) {
        console.error('Fetch Error -', err);
        document.getElementById('email-signup').classList.remove('preload');
        document.getElementById('email-signup').innerHTML = 'Signup';
        document.getElementById('email-signup').disabled = false;
      });
    });
  }

  if(document.getElementById('send-brochure-form')){

    let button = document.getElementById('send-brochure-form');
    let terms2 = document.querySelector('.contact-form [name=consent]');
    if(terms2) {
      terms2.onchange = function() {
        button.disabled = !this.checked;
      };
    }

    document.getElementById('send-brochure-form').addEventListener("click", function(e) {
      e.preventDefault();
      document.body.classList.remove('loaded');

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let email = document.querySelector('#contact-form [name=email]').value;
          let name = document.querySelector('#contact-form [name=name]').value;
          let telephone = document.querySelector('#contact-form [name=telephone]').value;
          let company = '';
          if (document.querySelector('#contact-form [name=company]')){
            company = document.querySelector('#contact-form [name=company]').value;
          }
          let comments = '';
          if (document.querySelector('#contact-form [name=employees]') && document.querySelector('#contact-form [name=fleet]')){
            comments = 'Number of employees: ' + document.querySelector('#contact-form [name=employees]').value +
              '\n\r Fleet Size: ' + document.querySelector('#contact-form [name=fleet]').value +
              '\n\r Message: ' + document.querySelector('#contact-form [name=comments]').value;
          } else {
            comments = document.querySelector('#contact-form [name=comments]').value;
          }
          let token = document.querySelector('#contact-form [name=_token]').value;
          let recaptcha = document.querySelector('#contact-form input[name=g-recaptcha-response]').value;

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'type': 'Brochure Form',
              'name': name,
              'company': company,
              'email': email,
              'telephone': telephone,
              'comments': comments,
              '_token': token,
              'g-recaptcha-response': recaptcha
            }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status!='ok'){
              let errors = '';
              for (let i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              return alert('There was a problem with your form\n\n'+errors);
            }

            document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-content')[0].classList.add('hidden');
            document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
            document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Contact Form Submit'
            });

          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });

        });
      });

    });
  }


  // Uncheck compliance checkboxes
  let checkboxes = document.querySelectorAll('form [name=consent]');
  if(checkboxes.length > 0) {
    checkboxes.forEach(value => {
      value.checked = false;
    })
  }

  // Charging Speeds
  if (document.querySelector('#charging-speeds')) {
    function isElementVisible(el) {
      let rect     = el.getBoundingClientRect(),
        vWidth   = window.innerWidth || document.documentElement.clientWidth,
        vHeight  = window.innerHeight || document.documentElement.clientHeight,
        efp      = function (x, y) { return document.elementFromPoint(x, y) };
      if (rect.right < 0 || rect.bottom < 0
        || rect.left > vWidth || rect.top > vHeight)
        return false;
      return (
        el.contains(efp(rect.left,  rect.top))
        ||  el.contains(efp(rect.right, rect.top))
        ||  el.contains(efp(rect.right, rect.bottom))
        ||  el.contains(efp(rect.left,  rect.bottom))
      );
    }
    function scrollAnimTriggerCheck() {
      if (isElementVisible(document.querySelector('#charging-speeds .deal-charging-legend'))) {
        const speedHome = parseInt(document.getElementById('progress_bar_home').getAttribute('data-speed'));
        const speedFast = parseInt(document.getElementById('progress_bar_fast').getAttribute('data-speed'));
        const speedRapid = parseInt(document.getElementById('progress_bar_rapid').getAttribute('data-speed'));
        const speedUltra = parseInt(document.getElementById('progress_bar_ultra').getAttribute('data-speed'));
        const homeWidth = (speedHome / speedHome) * 100;
        document.body.style.setProperty('--position-home', homeWidth);
        const fastWidth = (speedFast / speedHome) * 100;
        document.body.style.setProperty('--position-fast', fastWidth);
        const rapidWidth = (speedRapid / speedHome) * 100;
        document.body.style.setProperty('--position-rapid', rapidWidth);
        const ultraWidth = (speedUltra / speedHome) * 100;
        document.body.style.setProperty('--position-ultra', ultraWidth);

        document.removeEventListener("scroll", scrollAnimTriggerCheck);
      }
    }
    document.addEventListener("scroll", scrollAnimTriggerCheck);
  }
  if (document.querySelector('#charging-speeds1')) {
    function isElementVisible(el) {
      let rect     = el.getBoundingClientRect(),
        vWidth   = window.innerWidth || document.documentElement.clientWidth,
        vHeight  = window.innerHeight || document.documentElement.clientHeight,
        efp      = function (x, y) { return document.elementFromPoint(x, y) };
      if (rect.right < 0 || rect.bottom < 0
        || rect.left > vWidth || rect.top > vHeight)
        return false;
      return (
        el.contains(efp(rect.left,  rect.top))
        ||  el.contains(efp(rect.right, rect.top))
        ||  el.contains(efp(rect.right, rect.bottom))
        ||  el.contains(efp(rect.left,  rect.bottom))
      );
    }
    function scrollAnimTriggerCheck() {
      if (isElementVisible(document.querySelector('#charging-speeds1 .deal-charging-legend'))) {
        const speedHome = parseInt(document.getElementById('progress_bar_home1').getAttribute('data-speed'));
        const speedFast = parseInt(document.getElementById('progress_bar_fast1').getAttribute('data-speed'));
        const speedRapid = parseInt(document.getElementById('progress_bar_rapid1').getAttribute('data-speed'));
        const speedUltra = parseInt(document.getElementById('progress_bar_ultra1').getAttribute('data-speed'));
        const homeWidth = (speedHome / speedHome) * 100;
        document.body.style.setProperty('--position-home', homeWidth);
        const fastWidth = (speedFast / speedHome) * 100;
        document.body.style.setProperty('--position-fast', fastWidth);
        const rapidWidth = (speedRapid / speedHome) * 100;
        document.body.style.setProperty('--position-rapid', rapidWidth);
        const ultraWidth = (speedUltra / speedHome) * 100;
        document.body.style.setProperty('--position-ultra', ultraWidth);

        document.removeEventListener("scroll", scrollAnimTriggerCheck);
      }
    }
    document.addEventListener("scroll", scrollAnimTriggerCheck);
  }
  // END Charging Speeds

});

setTimeout(function(){
  //preloader
  document.documentElement.classList.add("site-loaded");
  document.body.classList.add("loaded");
}, 100);

window.onload = (function(){

  //preloader
  var root = document.getElementsByTagName( 'html' )[0];
  // root.classList.add("site-loaded");
  // document.body.classList.add("loaded");

  // Load Search Form
  if(document.getElementsByClassName('search-form').length>0){
    let $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
    loadManufacturers($type);

    // Search
    if(document.querySelectorAll('.search-form [name=make] option').length<=1){
      $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
      loadManufacturers($type);
      loadBodyTypes($type);
      if(document.querySelectorAll('.search-form [name=spec] option').length<=1){
        loadSpecs($type, document.querySelector('.search-form [name=model]').value);
      }
    }
    if(document.querySelectorAll('.search-form [name=model] option').length<=1){
      loadModels($type, document.querySelector('.search-form [name=make]').value);
    }
    if(document.querySelectorAll('.search-form [name=spec] option').length<=1){
      loadSpecs($type, document.querySelector('.search-form [name=model]').value);
    }

    document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
      $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
      loadModels($type, e.target.value);
      loadSpecs($type);
    });

    document.querySelector('.search-form [name=model]').addEventListener("change", function(e){
      $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
      loadSpecs($type, e.target.value);
    });
  }


});